import React from 'react';
import Text from '~components/atoms/Text';
import TabPageContainer from '~components/atoms/TabPageContainer';
import TabPageHeaderWrapper from '~components/atoms/TabPageHeaderWrapper';
import * as Styles from './_stockOut.module.scss';
import StockOutSearchAndFilterBar from './StockOutSearchAndFilterBar';
import StockOutTable from './StockOutTable';
import StockOutTablePaginator from './StockOutTablePaginator';
import ActionButton from '~components/atoms/ActionButton';
import { useAppDispatch, useAppSelector } from '~redux/hooks';
import combinedActions from '~redux/combinedActions';
import CreateStockOutModal from './CreateStockOutModal';

const StockOut = () => {
    const dispatch = useAppDispatch();

    const isOpen = useAppSelector(state => state.gold.modals.isCreateStockOutModalOpen);

    const handleOpenModal = () => dispatch(combinedActions.goldSetIsCreateStockOutModalOpen(true));
    const handleCloseModal = () => dispatch(combinedActions.goldSetIsCreateStockOutModalOpen(false));

    return (
        <TabPageContainer>
            <TabPageHeaderWrapper>
                <Text
                    label='Stock Out'
                    className={Styles.title}
                    isBold
                />

                <ActionButton
                    label='+ Create Stock Out'
                    onClick={handleOpenModal}
                />
            </TabPageHeaderWrapper>

            <StockOutSearchAndFilterBar />

            <StockOutTable />

            <StockOutTablePaginator />

            <CreateStockOutModal isOpen={isOpen} onClose={handleCloseModal} />
        </TabPageContainer>
    );
};

export default StockOut;
